import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../lib/utils.js';
export function Card({ className, ...props }) {
    return _jsx("div", { className: cn('rounded-xl border border-border bg-card shadow-sm', className), ...props });
}
export function CardHeader({ className, ...props }) {
    return (_jsx("div", { className: cn('border-b border-border px-4 py-3 text-xs font-medium uppercase tracking-wide text-muted-foreground', className), ...props }));
}
export function Table({ className, ...props }) {
    return _jsx("table", { className: cn('w-full text-sm', className), ...props });
}
export function TableHeader({ className, ...props }) {
    return _jsx("thead", { className: cn('border-b border-border bg-muted/40', className), ...props });
}
export function TableBody({ className, ...props }) {
    return _jsx("tbody", { className: cn('divide-y divide-border/60', className), ...props });
}
export function TableRow({ className, ...props }) {
    return _jsx("tr", { className: cn('transition-colors hover:bg-muted/40', className), ...props });
}
export function TableHead({ className, ...props }) {
    return (_jsx("th", { className: cn('px-4 py-2.5 text-left font-mono text-[10.5px] font-semibold uppercase tracking-wide text-muted-foreground', className), ...props }));
}
// Set `mono` on cells carrying the data voice — ids, sizes, counts, timestamps —
// to get IBM Plex Mono at 12px, tabular-nums, muted (the direction's data-cell
// recipe). Text cells stay in the UI face at the table's inherited `text-sm`.
export function TableCell({ mono, className, ...props }) {
    return (_jsx("td", { className: cn('px-4 py-2.5 align-middle', mono && 'font-mono text-xs tabular-nums text-muted-foreground', className), ...props }));
}
